import { toMantissaWithDollarSign } from 'modules/utils/number';
import { DataObject, TableCell as TableColumn } from 'types/common/table';

export const dataTablePriceRenderer = (row: DataObject, column: TableColumn) =>
  toMantissaWithDollarSign(row[column.key as string]);

export const renderNumber = <T extends DataObject>(
  row: T,
  column: TableColumn<T>,
): string => toMantissaWithDollarSign(row[column.key as keyof T] as string | number);

export const getTableRowNumber = (
  totalItems: number,
  defaultPageSize: number,
  currentPageIndex: number,
  rowIndex: number,
): number => totalItems - defaultPageSize * (currentPageIndex - 1) - rowIndex;
